export var ECheckboxState;
(function (ECheckboxState) {
    ECheckboxState["on"] = "on";
})(ECheckboxState || (ECheckboxState = {}));
